/**
 * ChannelBanner — Banner superiore con logo/nome partner.
 * Mostrato su tutte le pagine store quando il canale è valido.
 */
import React from 'react';
import { Handshake, BadgeCheck } from 'lucide-react';

export default function ChannelBanner({ channelInfo }) {
  if (!channelInfo?.valid) return null;

  const isReseller = channelInfo.channel_type === 'RESELLER';
  const partnerName = channelInfo.partner_name || 'Partner';

  return (
    <div className="relative bg-gradient-to-r from-slate-800 via-slate-900 to-slate-800 text-white overflow-hidden">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute -top-4 -right-8 w-32 h-32 rounded-full bg-yellow-400 blur-2xl" />
        <div className="absolute -bottom-4 -left-8 w-24 h-24 rounded-full bg-yellow-500 blur-2xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        {/* Left: partner info */}
        <div className="flex items-center gap-3 min-w-0">
          {channelInfo.partner_logo ? (
            <div className="flex-shrink-0 bg-white rounded-lg p-1.5 shadow-sm">
              <img
                src={channelInfo.partner_logo}
                alt={partnerName}
                className="h-8 w-auto object-contain max-w-[120px]"
              />
            </div>
          ) : (
            <div className="flex-shrink-0 bg-yellow-500/20 rounded-lg p-2">
              <Handshake className="w-5 h-5 text-yellow-400" />
            </div>
          )}

          <div className="min-w-0">
            <div className="flex items-center gap-1.5">
              <span className="text-sm font-semibold text-white truncate">
                {isReseller ? 'Rivenditore autorizzato' : 'In convenzione con'}{' '}
                {partnerName}
              </span>
              <BadgeCheck className="w-4 h-4 text-yellow-400 flex-shrink-0" />
            </div>
            <p className="text-xs text-slate-300 truncate">
              {isReseller
                ? 'Offerta dedicata tramite rivenditore certificato A-Sight'
                : `Offerta riservata — accedi ai servizi A-Sight tramite ${partnerName}`}
            </p>
          </div>
        </div>

        {/* Right: badge */}
        <div className="hidden sm:flex items-center gap-1.5 flex-shrink-0 bg-yellow-500/15 border border-yellow-500/30 rounded-full px-3 py-1">
          <Handshake className="w-3.5 h-3.5 text-yellow-400" />
          <span className="text-xs font-medium text-yellow-300">Partner ufficiale</span>
        </div>
      </div>
    </div>
  );
}
